import { CtaButton } from "@/components/Cta";
import { TYPICAL_PRICE_FALLBACK } from "@/config";

export const RenterPricing = ({ stats }) => {
  const typical = stats.typical_price || TYPICAL_PRICE_FALLBACK;
  return (
    <section data-testid="renter-pricing" className="nb-section">
      <div className="nb-shell">
        <p className="nb-eyebrow">Renter pricing</p>
        <h2 className="nb-h2 mt-4">What renting costs</h2>

        <p data-testid="renter-price-headline" className="mt-6 font-head text-2xl text-ink sm:text-3xl">
          The host's monthly price + <span className="nb-num">₹{stats.platform_fee_inr}</span> NightBay
          fee. That's it.
        </p>

        <p className="mt-6 max-w-[68ch] text-base text-ink2">
          Typical bays run <span className="nb-num">{typical}</span> a month depending on the locality
          and whether the bay is covered. The ₹{stats.platform_fee_inr} platform fee is flat,
          GST-inclusive and doesn't scale with the rent — you're charged one bundled monthly figure
          and it renews until you give notice.
        </p>

        <ul className="mt-8 grid gap-px overflow-hidden rounded-nb2 border border-line">
          {[
            "One month minimum, then month to month.",
            `${stats.cancellation_notice_days} days' notice to end a booking, either side.`,
            "No security deposit collected by NightBay. Anything the host asks for is between you and the host.",
            "A misdescribed bay reported within 48 hours of first use is refunded in full.",
          ].map((line, i) => (
            <li
              key={line}
              data-testid={`renter-price-point-${i}`}
              className="border-b border-line bg-surface2 px-4 py-4 text-sm text-ink2 last:border-b-0"
            >
              {line}
            </li>
          ))}
        </ul>

        <div className="mt-8">
          <CtaButton side="renter" testId="renter-pricing-cta">
            Find a spot near me
          </CtaButton>
        </div>
      </div>
    </section>
  );
};
